/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PlayableAdFormat = {
    TRIVIA: 'TRIVIA',
    MINI_GAME: 'MINI_GAME',
    VIDEO_ACTION: 'VIDEO_ACTION',
    PRODUCT_SHOWCASE: 'PRODUCT_SHOWCASE'
} as const;
export type PlayableAdFormat = typeof PlayableAdFormat[keyof typeof PlayableAdFormat];


export function instanceOfPlayableAdFormat(value: any): boolean {
    for (const key in PlayableAdFormat) {
        if (Object.prototype.hasOwnProperty.call(PlayableAdFormat, key)) {
            if (PlayableAdFormat[key as keyof typeof PlayableAdFormat] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlayableAdFormatFromJSON(json: any): PlayableAdFormat {
    return PlayableAdFormatFromJSONTyped(json, false);
}

export function PlayableAdFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayableAdFormat {
    return json as PlayableAdFormat;
}

export function PlayableAdFormatToJSON(value?: PlayableAdFormat | null): any {
    return value as any;
}

export function PlayableAdFormatToJSONTyped(value: any, ignoreDiscriminator: boolean): PlayableAdFormat {
    return value as PlayableAdFormat;
}

